import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Banner from '../Component/Banner';
import NavBar from './NavBar';
import Footer from './Footer';

function checkLightMode() {
    if (sessionStorage.getItem('lightMode') === 'true')  {
      return true
    }
  }

class AnimePage extends React.Component {
    render () {
        return (
            <>
                <Container className="text-center">
                    <NavBar testProps= { checkLightMode() ? "light" : "dark" } className="navTest"/>
                        <Row className="justify-content-md-center">
                            <Banner caption="Projects"/>
                        </Row>
                        <Row className="divider">
                            <p><h1><a href='/ChatbotAI'>Chatbot AI</a></h1></p>
                        </Row>
                        <Row className="divider">
                            <p><h1><a href='/DataVisualizer'>Data Visualizer</a></h1></p>
                        </Row>
                </Container>
                <Footer testProps= { checkLightMode() ? "lightMode" : "darkMode" }/>
            </>
        )
    }
}

export default AnimePage;